module.exports = __webpack_public_path__ + "img/basketball_hoop.5746363f.jpg";